import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { INode } from '@obvious.tech/constellation'

export const Node = defineEntity('Node', {
  endpoint: 'connectors/api/Node',
  schema: SNoop<INode>(),
})
